import {Swiper, SwiperSlide} from 'swiper/react'
import 'swiper/css'
import {infoIcon} from '@img/index.js'

export default function InfoButtons({onInfoPopup}) {
    return (
        <div className="[&_.swiper-slide]:w-auto md:[&_.swiper-wrapper]:justify-center">
            <Swiper slidesPerView="auto" spaceBetween={10}>
                <SwiperSlide>
                    <button type="button" onClick={() => onInfoPopup('payAfterDropoff')} className="cursor-pointer inline-flex items-center gap-2 px-5 py-2.5 border border-(--bg-dark-grey) rounded-full text-sm font-semibold whitespace-nowrap bg-transparent">
                        <span>Pay after drop-off</span>
                        <img src={infoIcon} alt="" className="w-4.5 h-4.5 shrink-0"/>
                    </button>
                </SwiperSlide>
                {/* Merged: the old separate "Cancellation & Change" + "Refund" pills now open
                    one CMR popup (opens on the Cancellation tab; Refund is a tab within it). */}
                <SwiperSlide>
                    <button type="button" onClick={() => onInfoPopup('cancellation')} className="cursor-pointer inline-flex items-center gap-2 px-5 py-2.5 border border-(--bg-dark-grey) rounded-full text-sm font-semibold whitespace-nowrap bg-transparent">
                        <span>Cancellation, Change & Refund</span>
                        <img src={infoIcon} alt="" className="w-4.5 h-4.5 shrink-0"/>
                    </button>
                </SwiperSlide>
            </Swiper>
        </div>
    )
}
